import type { ReactElement } from 'react';

import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import NotFound from './NotFound';
import GeneralError from './GeneralError';

const RouterError = (): ReactElement => {
  const error = useRouteError() as Error | undefined;
  if (isRouteErrorResponse(error)) {
    return <NotFound />;
  }
  return <GeneralError error={error} />;
};

export default RouterError;
